import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-md px-4 py-24 text-center">
      <h1 className="text-5xl font-bold text-navy mb-3">404</h1>
      <p className="text-navy-600 mb-6">We couldn't find that page.</p>
      <Link to="/" className="btn-primary">
        Back home
      </Link>
    </div>
  );
}
